var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActiveFilters',{key:_vm.activeFilterKey,attrs:{"value":_vm.activeFilters,"filters":_vm.getFilters},on:{"input":_vm.changeAllFilters}})}
var staticRenderFns = []

export { render, staticRenderFns }